import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const streamPackagesCard = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s16,
    backgroundColor: themeVars.container.prominent.background.idle,
    marginBottom: space.s16,
    padding: space.s24,
    border: `1px solid ${themeVars.container.border.secondary}`,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    tablet: {
      flexDirection: 'row',
    },
  }),
]);

export const cardLeftContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s16,
  },
  responsiveStyle({
    mobile: {
      width: '100%',
    },
    tablet: {
      width: '50%',
    },
  }),
]);

export const streamPackagesHeader = style([
  typography.bodySm,
  {
    color: themeVars.container.foreground.primary,
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
  },
]);

export const streamPackagesTitle = style([
  typography.titleMd,
  {
    marginBottom: space.s8,
  },
]);

export const streamPackagesDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.primary,
  },
]);

export const exploreButton = style([
  {
    marginTop: 'auto',
    width: 'fit-content',
  },
]);

export const streamPackagesImageContainer = style([
  {
    position: 'relative',
    overflow: 'hidden',
  },
  responsiveStyle({
    mobile: {
      width: '100%',
    },
    tablet: {
      width: '50%',
    },
  }),
]);

export const streamPackagesImage = style([
  {
    width: 550,
  },
]);

export const gradientBlock = style([
  {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 100,
    background: `linear-gradient(to right, transparent, ${themeVars.container.prominent.background.idle})`,
  },
]);
